import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import  EmpDirBody  from './employeeDirectoryFold/EmpDirBody';
import { connect } from 'react-redux';

class EmployeeDirectory extends Component {
    static displayName = EmployeeDirectory.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
        }
        this.getUserInfo();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        //console.log("found data: " + JSON.stringify(data))
        this.setState({
            level: this.props.ourLevel
        });
        //this.recordComingHere();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "6",
    //        department: this.props.reduxData.userInfo.level,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    componentDidMount() {

    }

    render() {
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        //else {
            //You may be wondering why we have this component here at all. I'll tell you.
            //When the Employee Directory was first envisioned to be moved onto UnderTheHood, it was thought it might be cool if we could have two panels here. The left one would be for
            //the normal directory, where you could search for an employee or department and retrieve a list of employees or departments with employees in them that matched the search
            //parameter, and be able to see information about those employees. The right one would be a tree view of Hood College's organizational structure similar to what you see in the
            //Object Explorer in SSMS or the Solution Explorer in Visual Studio. At the root level would be the President, then the VPs directly beneath her, and you could open up each one
            //and see the departments beneath each one with the employees in them, and if any of those departments had departments beneath them you could open those up as well. This way,
            //someone could see the hierarchy of employees at any level. This top level component was designed to be able to encapsulate the child components for each panel so that they
            //could be viewed side by side within the same page.
            //Unfortunately, the only place that knows this structure is UltiPro, and it isn't exactly intelligent about it. The only way it knows this structure is by associating an
            //employee to their supervisor, and then information about their current department and which VP their boss (or their boss or their boss) reports to. This made it difficult
            //to try and extrapolate the structure of Hood, much less know what the names of most departments are, and eventually a more flat structure was decided on that more closely
            //emulated what UltiPro knows. Because this structure only really cares about what VP any department reports to and not whether a department exists within another department,
            //the tree view was not only unnecessary but basically unusable with the data we now had. So the reference to the tree view component that had been made as a placeholder 
            //was removed so that the search piece could reach across the screen, and this component became solely used to house that component.
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            {/*<div className="left-sidebar">*/}
                            {/*    <EmpDirTree />*/}
                            {/*</div>*/}
                           {/* <div className="empDirBody">*/}
                            <div>
                                <EmpDirBody />
                            </div>
                        </div>
                    )}
                </UserContext.Consumer>
            );
        //}
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(EmployeeDirectory);